import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { Link } from 'react-router-dom'
import { FormattedDate } from 'components/intl'
import { FilterAwards } from 'containers/filters'
import { BadgesLevels } from 'components/misc'
import { Table, Data } from 'components/layout/Table'
import { awards as awardsLayout } from 'constants/layout'
import { apiAwards } from 'helpers/decorators/api'
import { meta } from 'helpers/decorators'
import config from 'config'

@meta({
  title: 'Awards'
})
@apiAwards({
  list: true
})
class AwardsList extends Component {
  static propTypes = {
    awards: PropTypes.object.isRequired,
    setAwardsLimit: PropTypes.func,
    setAwardsSort: PropTypes.func,
    setAwardsOffset: PropTypes.func
  }

  render() {
    const {
      awards: { loading, list, offset, limit, pages, sort },
      setAwardsLimit,
      setAwardsSort,
      setAwardsOffset
    } = this.props

    return (
      <div>
        <FilterAwards />
        <Table
          loading={loading}
          length={list.length}
          offset={offset}
          limit={limit}
          pages={pages}
          sort={sort}
          ths={awardsLayout.tableHeaders}
          onLimitChange={setAwardsLimit}
          onPaginationChange={setAwardsOffset}
          onSortChange={setAwardsSort}
        >
          <Data>
            {list.map(
              ({
                id,
                participant,
                awardLevel,
                creationDate,
                completionText
              }) => (
                <tr key={id}>
                  <td>
                    <Link
                      to={{
                        pathname: `${config.publicPath}/participants/${get(participant, 'id')}/detail`
                      }}
                    >
                      {get(participant, 'globalId')}
                    </Link>
                  </td>
                  <td>
                    {get(participant, 'firstName')}
                  </td>
                  <td>
                    {get(participant, 'lastName')}
                  </td>
                  <td>
                    <BadgesLevels levels={[{ awardLevel }]} activeOnly />
                  </td>
                  <td>
                    {creationDate && <FormattedDate value={creationDate} />}
                  </td>
                  <td>{completionText}</td>
                </tr>
              )
            )}
          </Data>
        </Table>
      </div>
    )
  }
}

export default AwardsList
